var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "menu-list"
  }, [_c('simple-table', {
    attrs: {
      "columns": _vm.columns
    },
    scopedSlots: _vm._u([{
      key: "tableBody",
      fn: function fn() {
        return [_c('tr', [!_vm.rows.records || _vm.rows.records.length == 0 ? _c('td', {
          attrs: {
            "colspan": _vm.columns.length,
            "align": "center"
          }
        }, [_vm._v(" No records found. ")]) : _vm._e()]), _vm._l(_vm.rows.records, function (row, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(row.id))]), _c('td', [_c('strong', [_vm._v(_vm._s(row.title))])]), _c('td', [_c('div', {
            staticClass: "action-icons"
          }, [_c('custom-button', {
            attrs: {
              "title": "Manage Menu",
              "iconClass": "fa fa-cog"
            },
            on: {
              "onClicked": function onClicked($event) {
                return _vm.onManageClick(row);
              }
            }
          })], 1)])]);
        })];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }